<template>
  <TimerPreview :timer="timer" :empty="empty" gallery />
</template>

<script>
import TimerPreview from "../../../../components/TimerPreview";

export default {
  name: "table-gallery-item",
  props: { timer: Object, empty: Boolean },
  components: {
    TimerPreview,
  },
};
</script>

<style></style>
